import { createStyles } from 'antd-style';
const useStyle = createStyles(({ token, css }) => ({
  layout: css`
    width: 100%;
    height: 100vh;
    min-height: 500px;
    border-radius: ${token.borderRadius}px;
    display: flex;
    flex-direction: column;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    font-family: 'SourceHanSansCN', '975MaruSC', AlibabaPuHuiTi, ${token.fontFamily}, sans-serif;
    position: relative;
    overflow: hidden;

    /* 如果背景图片加载失败，使用备用背景色 */
    background-color: ${token.colorBgContainer};

    .ant-prompts {
      color: ${token.colorText};
    }

    @media (max-width: 768px) {
      height: 100vh;
      min-height: 100vh;
      background-attachment: scroll;
    }
  `,
  menu: css`
    background: ${token.colorBgLayout}80;
    width: 280px;
    min-width: 280px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    @media (max-width: 768px) {
      display: none;
    }
  `,
  menuOverlay: css`
    display: none;
  `,
  menuButton: css`
    display: none;
    position: fixed;
    top: 16px;
    left: 16px;
    z-index: 1001;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    @media (max-width: 768px) {
      display: block;
    }
  `,
  conversations: css`
    padding: 0 12px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    @media (max-width: 768px) {
      padding: 0 8px;
    }
  `,
  chat: css`
    height: 100%;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: ${token.paddingLG}px;
    gap: 16px;
    overflow: hidden;

    @media (max-width: 1200px) {
      max-width: 100%;
      padding: ${token.padding}px;
    }

    @media (max-width: 768px) {
      padding: ${token.paddingSM}px;
      gap: 12px;
      width: 100%;
    }
  `,
  messages: css`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;

    /* 用户消息样式 - 高优先级 */
    .ant-bubble-list-item[data-placement="end"] .ant-bubble-content {
      background-color: #0068FF !important;
      color: #FFFFFF !important;
      border-radius: 16px !important;
    }

    /* AI 消息样式 - 高优先级 */
    .ant-bubble-list-item[data-placement="start"] .ant-bubble-content {
      background-color: #F6F6F6 !important;
      color: #000000 !important;
      border-radius: 16px !important;
    }
  `,
  placeholder: css`
    padding-top: 32px;
    width: 100%;
    max-width: 652px;
    margin: 0 auto;

    @media (max-width: 768px) {
      padding-top: 16px;
      width: 100%;
    }

    @media (max-width: 480px) {
      padding-top: 8px;
    }
  `,
  sender: css`
    box-shadow: ${token.boxShadow};
    flex-shrink: 0;
    background-color: #FFFFFF;
    margin-bottom: 20px;

    /* 去掉 Sender 组件 focus-within 时的蓝色边框和阴影 */
    &:focus-within,
    &.ant-sender:focus-within,
    &[class*="ant-sender"]:focus-within {
      box-shadow:rgba(0, 0, 0, 0.08) 0px 6px 16px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px -4px, rgba(0, 0, 0, 0.05) 0px 9px 28px 8px;
      border-color: #d9d9d9 !important;
    }

    /* 覆盖 Ant Design 的 where 选择器样式 - 使用更具体的选择器 */
    &[class*="css-dev-only-do-not-override"]:focus-within,
    :where([class*="css-dev-only-do-not-override"]).ant-sender:focus-within {
      box-shadow:rgba(0, 0, 0, 0.08) 0px 6px 16px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px -4px, rgba(0, 0, 0, 0.05) 0px 9px 28px 8px;
      border-color: #d9d9d9 !important;
    }

    /* 去掉输入框选中时的蓝色边框 */
    input,
    textarea,
    .ant-input,
    .ant-input:focus,
    .ant-input-focused,
    .ant-input-affix-wrapper:focus,
    .ant-input-affix-wrapper-focused {
      border-color: #ffffff !important;
    }
    
   .ant-sender-actions-btn-disabled {
      opacity: 0.6;
      background-color: rgba(0, 0, 0, 0.15);
      cursor: not-allowed;
      color: white !important;
    }
   .ant-btn.ant-sender-actions-btn-disabled .anticon {
     color: white !important;
   }
     .ant-sender-actions-list-presets > *:last-child .anticon {
      color: white !important;
     }
    .ant-input:hover,
    .ant-input-affix-wrapper:hover {
      // border-color: #d9d9d9 !important;
    }

    /* 右侧所有图标样式 - 改为黑色，调大一号 */
    * .anticon {
      // color: #000000 !important;
      font-size: 20px !important;
    }

    /* 按钮中的图标 */
    button .anticon,
    .ant-btn .anticon {
      color: #000000 !important;
      font-size: 20px !important;
    }

    /* 后缀图标（语音、发送等） */
    .ant-input-suffix .anticon,
    .ant-input-affix-wrapper .ant-input-suffix .anticon {
      color: #000000 !important;
      font-size: 20px !important;
    }

    /* placeholder 样式 */
    input::placeholder,
    textarea::placeholder,
    .ant-input::placeholder,
    .ant-input-affix-wrapper .ant-input::placeholder {
      font-family: '975MaruSC', sans-serif !important;
      font-size: 18px !important;
      color: #A0A0A0 !important;
      font-weight: normal !important;
      letter-spacing: 1px !important;
    }
  `,
  logo: css`
    display: flex;
    height: 72px;
    min-height: 72px;
    align-items: center;
    justify-content: start;
    padding: 0 24px;
    box-sizing: border-box;
    flex-shrink: 0;

    @media (max-width: 768px) {
      padding: 0 16px;
      height: 64px;
      min-height: 64px;
    }

    img {
      width: 24px;
      height: 24px;
      display: inline-block;
      flex-shrink: 0;
    }

    span {
      display: inline-block;
      margin: 0 8px;
      font-weight: bold;
      color: ${token.colorText};
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  `,
  addBtn: css`
    background: #1677ff0f;
    border: 1px solid #1677ff34;
    width: calc(100% - 24px);
    margin: 0 12px 24px 12px;
    flex-shrink: 0;

    @media (max-width: 768px) {
      width: calc(100% - 16px);
      margin: 0 8px 16px 8px;
    }
  `,
  chatHeader: css`
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: ${token.colorBgContainer};
    border-bottom: 1px solid ${token.colorBorder};
    flex-shrink: 0;

    @media (max-width: 768px) {
      display: flex;
    }
  `,
  topHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    // background: #ffffff;
    // background-color: rgba(255, 255, 255, 0.6);
    color: #333;
    flex-shrink: 0;
    position: relative;
    z-index: 1000;
    // border-bottom: 1px solid #f0f0f0;

    @media (max-width: 768px) {
      padding: 12px 16px;
    }

    .ant-typography {
      color: #333 !important;
      margin: 0;
    }
    
    /* 确保头部文本的字体样式生效 */
    .ant-typography-strong {
      font-family: '975MaruSC', sans-serif !important;
      font-weight: 400 !important;
    }

    .ant-btn-text {
      color: #333;
      
      &:hover {
        color: #1677ff;
        background-color: rgba(22, 119, 255, 0.06);
      }
    }
    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
    }

    .header-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      text-align: center;
    }

    .header-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      line-height: 22px;
      margin: 0;
    }

    .header-subtitle {
      font-size: 12px;
      color: #999;
      line-height: 16px;
      margin: 0;
      margin-top: 2px;
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;
      justify-content: flex-end;
    }

    .headerActions {
      .anticon {
        font-size: 20px !important;
      }

      .ant-btn {
        padding: 4px 6px;
      }
    }
  `,
  menuDrawer: css`
    @media (min-width: 769px) {
      .ant-drawer-content-wrapper {
        display: none !important;
      }
    }
  `,
  voiceInputBar: css`
    width: 100%;
    height: 54px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #FFFFFF;
    padding: 0 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
    margin-bottom: 20px;
    touch-action: none; /* 防止触摸时的默认行为（如滚动） */
  `,
  recordingText: css`
    flex: 1;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    font-family: 'SourceHanSansCN', sans-serif;
    font-style: normal;
    letter-spacing: 3px;
  `,
  recordingOverlay: css`
    position: fixed;
    top: 80%;
    left: 0;
    right: 0;
    bottom: 0;
    background:radial-gradient(circle at bottom center, #2196F3 0%, #E3F2FD 70%, hsla(0, 0%, 100%, 0) 100%);
    // background:linear-gradient(180deg, hsla(0, 0%, 100%, 0.1) 0%, #E3F2FD 20%, #2196F3 100%);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    pointer-events: auto;
  `,
  recordingContent: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    width: 100%;
    max-width: 100%;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
  `,
  recordingHint: css`
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    font-family: 'SourceHanSansCN', sans-serif;
    text-align: center;
    letter-spacing: 2px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
  `,
  waveform: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    width: 100%;
    max-width: 600px;
    padding: 0 20px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
  `,
  waveBar: css`
    flex: 1;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 2px;
    animation: waveAnimation 1.2s ease-in-out infinite;
    min-width: 2px;
    max-width: 6px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;

    @keyframes waveAnimation {
      0%, 100% {
        height: 4px;
        opacity: 0.5;
        transform: scaleY(1);
      }
      25% {
        height: 12px;
        opacity: 0.8;
        transform: scaleY(1.2);
      }
      50% {
        height: 18px;
        opacity: 1;
        transform: scaleY(1.5);
      }
      75% {
        height: 12px;
        opacity: 0.8;
        transform: scaleY(1.2);
      }
    }
  `,
}));

export default useStyle;
